export const REM = Number.parseFloat(
  window.getComputedStyle(document.documentElement).fontSize
)
